import React, { useContext } from "react";
import { useLocale } from "../../hooks/useLocale";
import { Link as GatsbyLink } from "gatsby";
import styled from "styled-components";
import { theme } from "../../theme/theme";

import { LocaleContext } from "../../contexts/LocaleContext";

export const LocaleLink = styled(GatsbyLink)<{ color: string }>`
  margin: 0;
  color: ${(p) => p.color};

  &.localeLinkDesktop {
    padding: 5px 20px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
  }
  @media screen and (max-width: 1051px) {
    &.localeLinkDesktop {
      display: none;
    }
  }
`;

export const LanguageSelectButton = ({
  className,
  color = theme.primary,
  disabledPaths
}: {
  className?: string;
  color?: string;
  disabledPaths?: string[];
}) => {
  const locale = useLocale();
  const { pathname } = useContext(LocaleContext);
  const to = locale === "en" ? "" : "/en";

  const path = pathname.replace(/\/(en|fi)/, "");

  if (disabledPaths?.find((p) => path.includes(p))) {
    return null;
  }

  return (
    <LocaleLink
      color={color}
      className={className}
      to={to + path}
      activeClassName="active"
      aria-label="Change language"
    >
      {locale === "en" ? "FI" : "EN"}
    </LocaleLink>
  );
};
